import React from 'react'
import { pluralizeToString } from 'lib/pluralize'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'

interface Props {
  offer: App.CruiseOffer;
}

const CruiseDetailsBodyText = styled(BodyText)`
  align-items: center;
  display: flex;

  > * + *::before {
    color: ${({ theme }) => theme.palette.neutral.one};
    content: "·";
    margin: 0 ${rem(4)};
    speak-as: bullets;
    speak: none;
  }
`

function CruiseDescription({ offer }: Props) {
  const cities = offer.itinerary?.map((event) => {
    const { port } = event
    if (!port) return
    return port.city || port.name.split(',')[0]
  }).filter((city) => city && city.length > 1)

  const countries = offer.itinerary?.map((itineraryItem) => {
    const { port } = itineraryItem
    if (!port) return
    return port.countryCode
  }).filter(country => country && country.length)

  const placesCount = [...new Set(cities)].length
  const countriesCount = [...new Set(countries)].length

  return (
    <Group direction="vertical" gap={8}>
      <CruiseDetailsBodyText variant="small" colour="neutral-two">
        {offer.cruiseLine.name} · {offer.ship.name}
      </CruiseDetailsBodyText>
      <CruiseDetailsBodyText variant="small" colour="neutral-two">
        <div>{pluralizeToString('night', offer.duration)}</div>
        {!!placesCount && <div>{pluralizeToString('port', placesCount)}</div>}
        {!!countriesCount && <div>{pluralizeToString('country', countriesCount)}</div>}
      </CruiseDetailsBodyText>
    </Group>
  )
}

export default CruiseDescription
